//@flow
import addDays from 'date-fns/add_days';
import format from 'date-fns/format';

import type QuoteModel from '../Stores/Quote/quoteModel';
import type QuoteTotalsModel from '../Stores/Quote/quoteTotalsModel';

export function getShipDate():string {
  // ship date is 2 days from today
  return format(addDays(new Date(), 2), 'Do');
}

// IMPORTANT: the return value of this function
// maps to the name of the special s2s discount
// returned by api.  Only change this if there is
// an equivalent change in magento. Otherwise
// some business and rendering logic is affected
// in avrio
export function getSubDiscountName() {
  return 'Subscribe to save';
}

export function isDiscountNotApplicable(quote:QuoteModel, quoteTotals:QuoteTotalsModel) {
  return quote.isSubscription() && !quoteTotals.getSub2SaveDiscount();
}
